const DEFINIR_USUARIO_LOGADO = (state, { access_token, user, me }) => {
  state.access_token = access_token
  state.user = user
  state.me = me
}

const CRIA_MENU_ITEM = (state, menuItems) => {
  state.menuItems = menuItems
  state.menuItemsRotas = menuItems
}

const DESLOGAR_USUARIO = (state) => {
  state.access_token = null
  state.user = null
  state.menuItems = null
}

const SET_ROTA = (state, rota) => {
  state.rotaAtual = rota;
}

const SET_IP = (state, rota) => {
  state.ip = rota;
}

const FILTRO_OPERACAO = (state, filtro) => {
  state.filtroRdv = filtro
}

const FILTRO_TELEMETRIA = (state, filtro) => {
  state.filtroTelemetria = filtro
}

const FILTRO_TOMADOR = (state, filtro) => {
  state.filtroTomador = filtro
}

const ENVIAR_NOTIFICACAO = (state, filtro) => {
  state.notificacao = filtro;
}

const PARAMETROS_RDV_COOPERADO = (state, parametros) => {
  state.rdvCooperado = parametros;
}

const PARAMETROS_VEICULO_COOPERADO = (state, parametros) => {
  state.veiculoCooperado[parametros.index] = parametros.item;
}

const SET_DEBUG = (state) => {
  state.debug = !state.debug;
}

const RESET_STATE = (state) => {
  state.rdvCooperado = null;
  state.cooperadoVeiculo = [];
  state.filtroRdv = null;
  state.filtroTelemetria = null;
  state.filtroTomador = null;
  state.termoLgpd = false;
  state.termoAssembleia = null;
  state.validaTermoAssembleia = false;
  state.assinaturaEletronica = false;
  state.infoBancaria= false;
  state.telEmergencia = false;
  state.aceiteFiliacao = false;
  state.filtroMatricula = false;
  state.nrMatricula = false;
  state.eSocial = false;
}

const SET_MOSTRA_MENU = (state, parametros) => {
  state.mostraMenu = parametros;
}

const FILTRO_MEMORIA_CALCULO = (state, filtro) => {
  state.filtroMemoriaCalculo = filtro
}

const HEADER_MEMORIA_CALCULO = (state, filtro) => {
  state.headerMemoriaCalculo = filtro
}

const FECHAMENTO_CONTA_CAPITAL = (state, filtro) => {
  state.fechamentoContaCapital = filtro
}

const VALIDA_TERMO_LGPD = (state, param) => {
  state.termoLgpd = param
}

const TERMO_ASSEMBLEIA = (state, param) => {
  state.termoAssembleia = param
}

const VALIDA_TERMO_ASSEMBLEIA = (state, param) => {
  state.validaTermoAssembleia = param
}

const VALIDA_ASSINATURA_ELETRONICA = (state, param) => {
  state.assinaturaEletronica = param
}

const ACEITE_FILIACAO = (state, param) => {
  state.aceiteFiliacao = param
}

const INFO_BANCARIA = (state, param) => {
  state.infoBancaria = param
}

const TEL_EMERGENCIA = (state, param) => {
  state.telEmergencia = param
}

const FILTRO_CONTA_CAPITAL = (state, param) => {
  state.filtroMatricula = param
}

const MATRICULA_CONTA_CAPITAL = (state, param) => {
  state.nrMatricula = param
}

const VALIDA_ESOCIAL = (state, param) => {
  state.eSocial = param
}

export {
  DEFINIR_USUARIO_LOGADO,
  DESLOGAR_USUARIO,
  CRIA_MENU_ITEM,
  FILTRO_OPERACAO,
  FILTRO_TELEMETRIA,
  FILTRO_TOMADOR,
  ENVIAR_NOTIFICACAO,
  PARAMETROS_RDV_COOPERADO,
  PARAMETROS_VEICULO_COOPERADO,
  RESET_STATE,
  SET_ROTA,
  SET_DEBUG,
  SET_MOSTRA_MENU,
  SET_IP,
  FILTRO_MEMORIA_CALCULO,
  HEADER_MEMORIA_CALCULO,
  FECHAMENTO_CONTA_CAPITAL,
  VALIDA_TERMO_LGPD,
  TERMO_ASSEMBLEIA,
  VALIDA_TERMO_ASSEMBLEIA,
  VALIDA_ASSINATURA_ELETRONICA,
  ACEITE_FILIACAO,
  FILTRO_CONTA_CAPITAL,
  MATRICULA_CONTA_CAPITAL,
  VALIDA_ESOCIAL,
  INFO_BANCARIA,
  TEL_EMERGENCIA
}
